<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="기본정보" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-if="editable"
                  label="일지출력"
                  color="amber-7"
                  icon="print" />
                <c-btn
                  v-if="editable"
                  label="전체화면 보기"
                  @btnClicked="fullScreenReport" 
                  icon="receipt_long" />
                <c-btn
                  v-if="editable"
                  label="저장"
                  icon="save" />
                <c-btn
                  v-if="editable"
                  label="삭제"
                  icon="remove" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-6">
                <c-datepicker
                  label="작성일"
                  name="col1"
                  v-model="data.col1"
                />
              </div>
              <div class="col-6">
                <c-field
                  :editable="editable"
                  :data="data"
                  deptValue="col2"
                  type="dept_user"
                  label="작성부서 & 작성자"
                  name="col3"
                  v-model="data.col3">
                </c-field>
              </div>
              <div class="col-4">
                <c-plant required="true" type="edit" name="col0" v-model="data.col0" />
              </div>
              <div class="col-4">
                <c-select
                  :comboItems="whetherItems"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="col4"
                  label="날씨"
                  v-model="data.col4"
                ></c-select>
              </div>
              <div class="col-4">
                <c-text
                  :editable="editable"
                  label="온도"
                  suffix="℃"
                  name="col5"
                  v-model="data.col5">
                </c-text>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tabvertical">
          <c-tab
            type="vertical"
            :tabItems.sync="tabItems"
            :inlineLabel="true"
            v-model="tab"
            :dense="true"
            align="left"
            :height="tabHeight"
            :splitter="splitter"
            tabClass="bg-teal-2 text-gray-9 shadow-2"
            tabClassVertical="leftTabAlign"
          >
            <template v-slot:default="tab">
              <component
                :is="tab.component"
                :param="popupParam"
              />
            </template>
          </c-tab>
        </div>
      </div>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
// import selectConfig from '@/js/selectConfig';
// import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'daily-air-report-detail',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          reportId: '',
          isFullScreen: false,
        }
      },
    },
    contentHeight: null,
  },
  data() {
    return {
      splitter: { data: 185 },
      tab: 'tab1',
      tabItems: [
        { name: 'tab1', label: '1. 배출구별 가동(조업)시간', component: () => import(`${'./dailyAirReport01.vue'}`) },
        { name: 'tab2', label: '2. 방지시설 운전사항', component: () => import(`${'./dailyAirReport02.vue'}`) },
        { name: 'tab3', label: '3. 방지시설 보수내역', component: () => import(`${'./dailyAirReport03.vue'}`) },
        { name: 'tab4', label: '4. 연료사용량', component: () => import(`${'./dailyAirReport04.vue'}`) },
        { name: 'tab5', label: '5. 원료사용량', component: () => import(`${'./dailyAirReport05.vue'}`) },
      ],
      whetherItems: [
        { code: '1', codeName: '맑음' },
        { code: '2', codeName: '흐림' },
        { code: '3', codeName: '눈' },
        { code: '4', codeName: '비' },
        { code: '5', codeName: '구름' },
      ],
      data: {
        col0: '',
        col1: '2021-01-05',
        col2: 'D10003',
        col3: 'U000000018',
        col4: '1',
        col5: '15',
        col6: '',
        col7: '',
      },
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: false,
        width: '80%',
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 220);
    },
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.getData();
    },
    getData() {
    },
    fullScreenReport() {
      this.popupOptions.target = () => import(`${"./dailyAirReportFullScreen.vue"}`);
      this.popupOptions.title = '대기일지 전체';
      this.popupOptions.param = {
        reportId: this.popupParam.reportId,
        isFullScreen: true,
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  }
};
</script>